/**
 * eslint react/prop-types: 1, @typescript-eslint/no-unsafe-assignment: 1
 *
 * @format
 */

import {Box, Container} from '@chakra-ui/layout';
import {ReactElement} from 'react';
import Layout from '../components/Layout';
import LinkButton from '../components/LinkButton';
import getFooter from '../lib/api/acf/footer';
import getMainMenu from '../lib/api/acf/mainMenu';
import mappingFooter from '../patterns/Footer/mappingFooter';
import {HeroBannerPhotographic1} from '../patterns/HeroBanners/PhotographicBanner/PhotographicBanner1';
import mappingMainMenu from '../patterns/MainMenu/mappingMainMenu';

const heroData = {
	heroText: {
		heading: '404 Page not found',
		supportingText: '',
		variant: 'light',
	},
	backgroundColor: 'gneiss.700',
	image: {
		src: '/images/404.webp',
	},
};

// eslint-disable-next-line react/prop-types
export default function Custom404({mainMenu, footer}): ReactElement {
	return (
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		<Layout seo={{title: '404'}} mainMenu={mainMenu} footer={footer}>
			<Box>
				<Box as='section' overflow='hidden'>
					<HeroBannerPhotographic1
						heroText={heroData.heroText}
						hasBackground={true}
						backgroundColor={heroData.backgroundColor}
						image={heroData.image}
						backgroundHeight={'unset'}
					/>
					<Container maxW='container.xl' mx='auto'>
						<Box pt={{base: '10', md: '12'}} pb={{base: '16', md: '20'}}>
							<Box
								textStyle={{
									base: 'display6LeftDark',
									md: 'display5LeftDark',
								}}
								mb='8'>
								<h2>It looks like there is a problem!</h2>
							</Box>
							<Box
								textStyle={{
									base: 'paragraph1LeftDark',
								}}
								mb='8'>
								<p>Sorry, the page you are looking for could not be found.</p>
							</Box>

							<Box w={{base: '100%', md: 'auto'}}>
								<LinkButton
									px='30px'
									href='/'
									justifyContent={{base: 'center'}}
									display={{base: 'flex', md: 'inline-flex'}}
									text='Back to Home'
								/>
							</Box>
						</Box>
					</Container>
				</Box>
			</Box>
		</Layout>
	);
}

export async function getStaticProps({params, preview, previewData}) {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	let mainMenu = await getMainMenu();
	mainMenu = mappingMainMenu(mainMenu);
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	let footer = await getFooter();
	footer = mappingFooter(footer);

	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	return {props: {mainMenu, footer}};
}
